import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { AutoComplete, Icon as AIcon, Input } from 'antd';
import { CarIcon, Icon, BackIcon, FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../../core/icons'
import { change } from 'redux-form'
import { connect } from 'react-redux'
import {GoogleApiWrapper} from 'google-maps-react';
const Option = AutoComplete.Option;
const OptGroup = AutoComplete.OptGroup;

const resultsAsOptions = (data)=> data.map((opt,i) => (
      <Option key={opt.id} value={opt.id} data={opt} title={opt.description}>
        <MarkerIcon/>
        {' '}{opt.description}
      </Option>
    ))



class Complete extends React.Component {
  state = {
    dataSource: [
      // ...placesAsOptions(this.props.places)
    ],
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.places !== this.props.places) {
      this.setState({
        dataSource: [
          // ...placesAsOptions(this.props.places)
        ],
      })
    }
  }


  geolocate = () => {

          // // Bias the autocomplete object to the user's geographical location,
          // // as supplied by the browser's 'navigator.geolocation' object.

            // const ownProps = this.props
            //
            // if (navigator.geolocation) {
            //   console.log('get geolocation')
            //   navigator.geolocation.getCurrentPosition(function(position) {
            //     var geolocation = {
            //       lat: position.coords.latitude,
            //       lng: position.coords.longitude
            //     };
            //     var circle = new ownProps.google.maps.Circle({
            //       center: geolocation,
            //       radius: position.coords.accuracy
            //     });
            //     this.AutocompleteService.setBounds(circle.getBounds());
            //   });
            // }

  }

  handleSearch = (value) => {
    if (value.trim().length>0) {

      const AutocompleteService = new this.props.google.maps.places.AutocompleteService
      AutocompleteService.getPlacePredictions({ input: value }, (response)=>{
        response && this.setState({
          dataSource: [
            ...resultsAsOptions(response)
          ],
        });
      })
    } else {
      this.setState({
        dataSource: [
          // ...placesAsOptions(this.props.places)
        ],
      });
    }



  }

  render() {
    const { dataSource } = this.state;
    return (
      <div style={{
          display: 'flex',
          flexBasis: '100%'
      }}>
      <AutoComplete
        allowClear
        dataSource={dataSource}
        onSelect={this.props.onSelect}
        onSearch={this.handleSearch}

        optionLabelProp="title"
        placeholder="Search for place or address..."
        {...this.props}
        defaultValue={this.props.defaultValue}
      >
        <Input onFocus={this.geolocate} suffix={<AIcon type="search" className="certain-category-icon" />} />
      </AutoComplete>
    </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {

  return {
    ...ownProps,
  }
}


const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSelect: (value, option)=> {
      const selected = option.props.data


        if (selected.description) { // google response
          var geocoder = new ownProps.google.maps.Geocoder
          geocoder.geocode({'placeId': selected.place_id}, function(results, status) {
            if (status !== 'OK') console.error(status, 'google autocomplete err')
            if (status === 'OK') {
              if (results[0]) {

                // https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
                var adrComps = {
                        street_number: 'short_name',
                        route: 'long_name',
                        locality: 'long_name',
                        administrative_area_level_1: 'short_name',
                        country: 'long_name',
                        postal_code: 'short_name'
                      };

                // Get each component of the address from the place details
                // and fill the corresponding field on the form.
                const adrData = {}
                for (var i = 0; i < results[0].address_components.length; i++) {
                  var addressType = results[0].address_components[i].types[0];
                  if (adrComps[addressType]) {
                    var val = results[0].address_components[i][adrComps[addressType]];
                    adrData[addressType] = val
                  }
                }


                const destination = results[0].geometry.location.toJSON()
                const payload = {
                  latitude: destination.lat,
                  longitude: destination.lng,
                  street: (adrData.street_number || adrData.route) ? `${adrData.street_number} ${adrData.route}`:null,
                  street2: results[0].formatted_address,
                  city: adrData.locality,
                  state: adrData.administrative_area_level_1,
                  postal_code: adrData.postal_code,
                  country: adrData.country,
                  name: selected.structured_formatting.main_text,
                  name2: selected.description,
                  // if no street, city and state
                  // if custom name was already entered, dont override
                }

                dispatch({
                  type:'SELECT_FAVE_PLACE',
                  adrData,
                  payload,
                  // value,
                  selected,
                  // to: selected.description,
                  // destination,
                  results,
                  // center: destination,
                  // formatted_address: results[0].formatted_address
                })

                // remove unneeded keys
                const {street2, name2, name, ...data} = payload
                // set name if no prior custom name exists
                if (!ownProps.hasName) dispatch(change('favoritePlace', 'name', name))

                // loop and update all the redux form values
                Object.keys(data).forEach( key =>
                  dispatch(change('favoritePlace', key, data[key]))
                )
              }
            }
          })

        }


    }
  }
}

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
})(
  connect(mapStateToProps, mapDispatchToProps)(Complete)
)



// WEBPACK FOOTER //
// ./src/account/favorite-places/AutoComplete.js